import { render, staticRenderFns } from "./TemplatesCombobox.vue?vue&type=template&id=fe45f644&"
import script from "./TemplatesCombobox.vue?vue&type=script&lang=ts&"
export * from "./TemplatesCombobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports